export default "__VITE_ASSET__vQGA2PzV__";